export default __webpack_public_path__ + "static/media/urban_farming.fb56d6a7.png";